/* eslint-disable @typescript-eslint/naming-convention, @typescript-eslint/no-extraneous-class */
export class Roles {
  static SmartrPlus = 'SmartrPlus';
}
